export default __webpack_public_path__ + "static/IN-9008-vs-IN-5905_resTestBig-1153288d0942ca99fa22abde5e2bff6d.webp";